import { Controller } from "@hotwired/stimulus"

// Use this controller with data-action="link#follow" data-link-url-value="/path/to/follow?param=value"
// Specifying the id of a turbo frame as the frame value will cause the link to be followed in that turbo frame.
//
// By default buttons and links inside the scope of the controller (unless they are the controller element) will not
// trigger a follow, to block the link from being followed from other elements you can give them a data attribute
// to stop it: data-block-follow="true".
//
// Once a link has been followed inside a frame the followed event will be dispatched, this can then be used with other
// stimulus controllers.
export default class extends Controller {
  static get values() {
    return { url: String, frame: String }
  }

  connect() {
    if (this.frameValue) {
      this.frame = document.getElementById(this.frameValue)
    }
  }

  follow(event) {
    if (event.target.dataset.blockFollow) {
      return
    }

    if (["A", "BUTTON"].includes(event.target.tagName) && event.target !== this.element) {
      return
    }

    if (this.frame) {
      this.frame.src = this.urlValue
      this.frame.reload().then(() => {
        this.dispatch("followed", { detail: { url: this.urlValue, frame: this.frame } })
      })
    } else {
      Turbo.visit(this.urlValue)
    }
  }
}
